import { either, isEmpty, isNil, reject } from "ramda";

export const cleanNullValues = reject(either(isNil, isEmpty));
